<template>
  <b-navbar-item :tag="tag">
    <slot name="body" />
  </b-navbar-item>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'NavbarItemView',
  slotsDefinition: {
    body: {}
  },
  props: {
    tag: {
      type: String,
      default: 'a'
    }
  }
};
</script>
